import { useSyncExternalStore } from "react";

/**
 * Module-level set of background writes still in flight (keys like "event:<id>", "club:<id>"), so a
 * guard survives the owning component unmounting and remounting. The mobile app has no such guard;
 * on web it stops a newer edit being overwritten by an older edit's late image/logo/PDF attach.
 */
let snapshot = new Set();
const listeners = new Set();

function publish(next) {
  snapshot = next;
  listeners.forEach((l) => l());
}

export function markPending(key) {
  publish(new Set(snapshot).add(key));
}

export function clearPending(key) {
  const next = new Set(snapshot);
  if (next.delete(key)) publish(next);
}

/** Hook: the current Set of pending keys (a new Set on every change). */
export function usePendingWork() {
  return useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    () => snapshot
  );
}
